import { AuthPage } from './pages/AuthPage';
import './global.scss';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import {
  CocktailViewPage,
  CocktailsAddingPage,
  CocktailsListPage,
  CoctailEddingPage,
  ImagesPage,
  VideoPage,
  CreateGameCardPage,
  GameCardsPage,
  GameCardViewPage,
  GameCardEdingPage,
  AudioPage,
  TermsPage,
} from './pages';
import useCookie from './lib/hooks/useCookie';
import {
  AUDIO_PAGE,
  AUTH_TOKEN,
  COCKTAILS_PAGE,
  CREATE_GAME_CARD_PAGE,
  EDIT_COCKTAIL_PAGE,
  EDIT_GAME_CARD_PAGE,
  GAME_CARDS_PAGE,
  GREATE_COCKTAIL_PAGE,
  HOME_PAGE,
  IMAGES_PAGE,
  PRIVACY_POLICY_PAGE,
  VIDEO_PAGE,
  VIEW_COCKTAIL_PAGE,
  VIEW_GAME_CARD_PAGE,
} from './lib';
import { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const { getCookie } = useCookie();
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(getCookie(AUTH_TOKEN));

  const logIn = () => setIsLoggedIn(true);

  const logOut = () => setIsLoggedIn(false);

  // useEffect(() => {
  //   setCookie('logged_user', isLoggedIn);
  // }, [isLoggedIn]);

  const routes = [
    {
      path: HOME_PAGE,
      element: <CocktailsListPage logOut={logOut} />,
      withLogout: true,
    },
    {
      path: GREATE_COCKTAIL_PAGE,
      element: <CocktailsAddingPage logOut={logOut} />,
      withLogout: true,
    },
    ,
    {
      path: COCKTAILS_PAGE,
      element: <CocktailsListPage logOut={logOut} />,
      withLogout: true,
    },
    {
      path: EDIT_COCKTAIL_PAGE,
      element: <CoctailEddingPage logOut={logOut} />,
      withLogout: true,
    },
    {
      path: VIEW_COCKTAIL_PAGE,
      element: <CocktailViewPage logOut={logOut} />,
      withLogout: true,
    },
    {
      path: IMAGES_PAGE,
      element: <ImagesPage logOut={logOut} />,
      withLogout: true,
    },
    {
      path: VIDEO_PAGE,
      element: <VideoPage logOut={logOut} />,
      withLogout: true,
    },
    {
      path: CREATE_GAME_CARD_PAGE,
      element: <CreateGameCardPage logOut={logOut} />,
      withLogout: true,
    },
    {
      path: GAME_CARDS_PAGE,
      element: <GameCardsPage logOut={logOut} />,
      withLogout: true,
    },
    {
      path: VIEW_GAME_CARD_PAGE,
      element: <GameCardViewPage logOut={logOut} />,
      withLogout: true,
    },
    {
      path: EDIT_GAME_CARD_PAGE,
      element: <GameCardEdingPage logOut={logOut} />,
      withLogout: true,
    },
    {
      path: AUDIO_PAGE,
      element: <AudioPage logOut={logOut} />,
      withLogout: true,
    },
    {
      path: PRIVACY_POLICY_PAGE,
      element: <TermsPage />,
      withLogout: false,
    },
  ];

  return (
    <>
      <Router>
        <Routes>
          {routes.map(({ path, element, withLogout }, idx) => (
            <Route
              key={idx}
              path={path}
              element={withLogout ? isLoggedIn ? element : <AuthPage logIn={logIn} /> : element}
            />
          ))}
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
}

export default App;
